module.exports = __webpack_public_path__ + "static/media/08.e2e6dd34.png";